const SERVICE_ENABLED_FIELDS = {
  'tax-filing': 'isTaxFilingEnabled',
  bookkeeping: 'isBookkeepingEnabled',
  'usa-company': 'isUSAEnabled',
  'cfo-advisory': 'isCFOEnabled',
  'registered-agent': 'isRegisteredAgentEnabled',
  'annual-report': 'isAnnualReportServiceEnabled',
};

const FALLBACK_MAIN_NAV = [
  { key: 'dashboard', route: '/dashboard', label: 'Dashboard', icon: 'LuLayoutDashboard', order: 0 },
  { key: 'help', route: '/help', label: 'Help Guide', icon: 'LuCircleHelp', order: 1 },
  { key: 'documents', route: '/documents', label: 'Documents', icon: 'LuFolderKanban', order: 2 },
  { key: 'pricing', route: '/pricing', label: 'Pricing Plan', icon: 'LuCreditCard', order: 3 },
  { key: 'meetings', route: '/meetings', label: 'Meetings', icon: 'LuVideo', order: 4 },
];

const FALLBACK_SERVICE_NAV = [
  { key: 'tax-filing', route: '/tax-filing', label: 'Tax Filing', icon: 'LuClipboardCheck', order: 0 },
  { key: 'bookkeeping', route: '/bookkeeping', label: 'Bookkeeping', icon: 'LuBookOpenCheck', order: 1 },
  { key: 'usa-company', route: '/usa-company-formation', label: 'USA Company', icon: 'LuBuilding2', order: 2 },
  { key: 'cfo-advisory', route: '/cfo-advisory', label: 'CFO Advisory', icon: 'LuBriefcaseBusiness', order: 3 },
  { key: 'registered-agent', route: '/registered-agent', label: 'Registered Agent', icon: 'LuShieldCheck', order: 4 },
  { key: 'annual-report', route: '/annual-report', label: 'Annual Report Service', icon: 'LuCalendarDays', order: 5 },
];

const FALLBACK_REFER = {
  title: 'Refer & Earn',
  subtitle: 'Get 1000 Points!',
  icon: 'LuGift',
  route: '/refer-and-earn',
};

const FALLBACK_HEADER = {
  welcomePrefix: 'Hello,',
  welcomeSubtitle: 'Welcome back to your dashboard',
  notificationsTooltip: 'Notifications',
  notificationsTitle: 'Notifications',
  notificationsEmptyText: 'No new notifications',
  markAllReadText: 'Mark all read',
  chatButtonText: 'Chat with Docs',
  chatButtonIcon: 'FaComments',
  profileMenuText: 'View Profile',
  profileMenuIcon: 'FaUser',
  logoutText: 'Logout',
};

const sortNav = (items) =>
  (items || [])
    .filter((item) => item.isActive !== false)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

export const getSidebarContent = (content) => ({
  logo: {
    lightUrl: content?.logo?.lightUrl || '',
    darkUrl: content?.logo?.darkUrl || '',
    altText: content?.logo?.altText || 'BooksComply',
  },
  mainNav: sortNav(content?.mainNav?.length ? content.mainNav : FALLBACK_MAIN_NAV),
  servicesSectionTitle: content?.servicesSectionTitle || 'Services',
  serviceNav: sortNav(content?.serviceNav?.length ? content.serviceNav : FALLBACK_SERVICE_NAV),
  referAndEarn: { ...FALLBACK_REFER, ...(content?.referAndEarn || {}) },
  assigneeNav: content?.assigneeNav || {
    label: 'Bookkeeping',
    icon: 'LuBookOpenCheck',
    route: '/bookkeeping',
  },
});

export const isServiceNavDisabled = (itemKey, user) => {
  const field = SERVICE_ENABLED_FIELDS[itemKey];
  if (!field || !user) return false;
  return !user[field];
};

export const getHeaderContent = (content) => ({
  ...FALLBACK_HEADER,
  ...(content || {}),
});

export { SERVICE_ENABLED_FIELDS };
